import { Color } from '@tiptap/extension-color';
import Placeholder from '@tiptap/extension-placeholder';
import { TextStyle } from '@tiptap/extension-text-style';
import Underline from '@tiptap/extension-underline';
import { EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import { useEffect } from 'react';
import './texteditor.css';
import MenuBar from './ToolBar';

const extenstions = [
  StarterKit.configure({
    bulletList: {
      keepMarks: true,
      keepAttributes: false
    },
    orderedList: {
      keepMarks: true,
      keepAttributes: false
    },
    listItem: true,
    code: false,
    codeBlock: false
  }),
  Underline,
  TextStyle,
  Color.configure({
    types: ['textStyle']
  }),
  Placeholder.configure({
    placeholder: 'Type a message...',
    showOnlyWhenEditable: true,
    showOnlyCurrent: true
  })
];

const TextEditor = ({
  handleChange,
  value,
  isMenushow = true,
  className = '',
  emojiBoxPosition = '',
  onKeySubmit
}) => {
  const editor = useEditor({
    extensions: extenstions,
    content: '',
    editorProps: {
      attributes: {
        class: 'tiptap-editor-content ProseMirror'
      },
      handleKeyDown(view, event) {
        if (event.key === 'Enter' && !event.shiftKey) {
          if (onKeySubmit) {
            const text = view.state.doc.textContent.trim();
            if (text.length > 0) {
              event.preventDefault();
              onKeySubmit();
              return true;
            }
            // Empty message -- prevent Enter from doing anything
            event.preventDefault();
            return true;
          }
        }
        return false;
      },
      handlePaste(view, event) {
        const html = event.clipboardData?.getData('text/html');
        if (html) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          // Remove classes and !important from all elements
          doc.querySelectorAll('*').forEach((el) => {
            el.removeAttribute('class');
            const style = el.getAttribute('style');
            if (style) {
              el.setAttribute('style', style.replace(/!\s*important\s*/gi, ''));
            }
          });

          event.preventDefault();
          const cleanedHTML = doc.body.innerHTML;
          view.dispatch(view.state.tr.insertText(''));
          editor.commands.insertContent(cleanedHTML);
          return true;
        }
        return false;
      }
    },
    onUpdate: ({ editor }) => {
      let html = editor.getHTML();
      const plainText = editor.getText().trim();
      if (plainText.length > 0) {
        handleChange?.(html.toString());
      } else {
        handleChange?.('');
      }
    }
  });
  useEffect(() => {
    if (editor && value !== editor.getHTML()) {
      editor.commands.setContent(value);
    }
  }, [value, editor]);

  return (
    <div className="tiptap-editor-container">
      {isMenushow && (
        <div className="tiptap-toolbar-wrapper">
          <MenuBar editor={editor} emojiPosition={emojiBoxPosition} />
        </div>
      )}
      <div>
        <EditorContent editor={editor} className={className} />
      </div>
    </div>
  );
};

export default TextEditor;
